// CP4.1/CP4.4: bootstrap-vue-next's createBootstrap() installs only directives/composables — it registers
// no <b-*> components (bootstrap-vue 2's Vue.use did). Register the exact set the frontend's templates use.
// Global compat is MODE 3 (main.js), so bvn's native v-model is kept — no per-component compatConfig needed.
// Gaps handled by template rewrites in the b-* batch: <b-icon> -> bootstrap-icons-vue; <b-form-datepicker>
// and <b-input-group-append> have no bvn equivalent.
import {
  BButton,
  BCol,
  BContainer,
  BDropdownDivider,
  BDropdownForm,
  BDropdownItem,
  BFormCheckbox,
  BFormInput,
  BFormRow,
  BInputGroup,
  BNavItem,
  BNavItemDropdown,
  BNavText,
  BNavbar,
  BNavbarBrand,
  BNavbarNav,
  BSpinner,
  BTableSimple,
  BTbody,
  BTd,
  BTh,
  BThead,
  BTr
} from 'bootstrap-vue-next'

const components = {
  'b-button': BButton,
  'b-col': BCol,
  'b-container': BContainer,
  'b-dropdown-divider': BDropdownDivider,
  'b-dropdown-form': BDropdownForm,
  'b-dropdown-item': BDropdownItem,
  'b-form-checkbox': BFormCheckbox,
  'b-form-input': BFormInput,
  'b-form-row': BFormRow,
  'b-input-group': BInputGroup,
  'b-nav-item': BNavItem,
  'b-nav-item-dropdown': BNavItemDropdown,
  'b-nav-text': BNavText,
  'b-navbar': BNavbar,
  'b-navbar-brand': BNavbarBrand,
  'b-navbar-nav': BNavbarNav,
  'b-spinner': BSpinner,
  'b-table-simple': BTableSimple,
  'b-tbody': BTbody,
  'b-td': BTd,
  'b-th': BTh,
  'b-thead': BThead,
  'b-tr': BTr
}

export function registerBootstrapVueNext (app) {
  for (const [tag, component] of Object.entries(components)) {
    app.component(tag, component)
  }
}
